/**
 * Labelled auto-sync Toggle. Saves instantly on click; shows "Saving…" in
 * place of the label while the request is in flight. A failed save is
 * surfaced by the caller via ApiError, not inline here (spec: failures
 * raise the page-level band, not a toast).
 */
import React from "react";
import Toggle from "../../theme/untitled/Toggle/Toggle";
import styles from "./ConnectionRow.module.scss";

const AutoSyncSwitch = ({ checked, saving, onChange, disabled }) => (
  <div className={styles.autoSync}>
    <Toggle
      size="sm"
      checked={checked}
      disabled={disabled || saving}
      onChange={onChange}
      label={checked ? "Auto-sync on" : "Auto-sync off"}
    />
    <span className={styles.autoSyncLabel}>
      {saving ? "Saving…" : checked ? "Auto-sync on" : "Auto-sync off"}
    </span>
  </div>
);

export default AutoSyncSwitch;
